import { useState } from "react";
import { Modal, Input, notification } from "antd";
import { postData } from "../../api";
import { VerifyEmailCodeUrl, ResendVerifyCodeUrl } from "../../constants/endPoints";

/**
 * The "enter the code we emailed you" step, shown right after signup when the
 * admin has email verification turned on (Users::add_post returns status 2
 * instead of 1), and reused on the login page when someone tries to sign in
 * to an account that is still pending verification.
 *
 * Needs [userId] up front — the backend's verify endpoint takes user_id + code
 * together (it is not a code-only lookup like the password-reset one), so the
 * caller must already know it, either from the signup response or from a
 * locally-remembered pending signup (see pendingVerification.js).
 */
const VerifyCodeModal = ({ visible, userId, email, onVerified, onCancel }) => {
    const [code, setCode] = useState("");
    const [isVerifying, setIsVerifying] = useState(false);
    const [isResending, setIsResending] = useState(false);

    const verify = async () => {
        if (!code || code.trim().length < 1) {
            notification.error({
                message: "Erro",
                description: "Por favor insira o código enviado por email."
            });
            return;
        }
        setIsVerifying(true);
        const response = await postData(VerifyEmailCodeUrl, { user_id: userId, code: code.trim() }, true);
        setIsVerifying(false);
        if (response && response.data && response.data.user_id) {
            setCode("");
            onVerified(response.data);
        }
    };

    const resend = async () => {
        if (!email) return;
        setIsResending(true);
        const response = await postData(ResendVerifyCodeUrl, { user_email: email }, true);
        setIsResending(false);
        if (response && response.data && response.data.status === "success") {
            notification.success({
                message: "Sucesso",
                description: "Um novo código foi enviado para o seu email."
            });
        }
    };

    return (
        <Modal
            visible={visible}
            title="Verifique o seu email"
            onOk={verify}
            onCancel={onCancel}
            okText="Verificar"
            cancelText="Cancelar"
            confirmLoading={isVerifying}
        >
            <p>
                Enviámos um código de verificação para <strong>{email}</strong>.
                Insira-o abaixo para ativar a sua conta.
            </p>
            <Input
                placeholder="Código de verificação"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                onPressEnter={verify}
                maxLength={10}
                className="mb-2"
                autoFocus
            />
            <a href="#" onClick={(e) => { e.preventDefault(); if (!isResending) resend(); }}>
                {isResending ? "A enviar…" : "Reenviar código"}
            </a>
        </Modal>
    );
};

export default VerifyCodeModal;
